import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 368 368" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M328 16H40C18 16 0 34 0 56v256c0 22 18 40 40 40h288c22 0 40-18 40-40V56c0-22-18-40-40-40zm24 296c0 13.2-10.8 24-24 24H40c-13.2 0-24-10.8-24-24V56c0-13.2 10.8-24 24-24h288c13.2 0 24 10.8 24 24v256z" fill={color}/>
        <path d="M144 112h-32V80c0-4.4-3.6-8-8-8s-8 3.6-8 8v32H64c-4.4 0-8 3.6-8 8s3.6 8 8 8h32v32c0 4.4 3.6 8 8 8s8-3.6 8-8v-32h32c4.4 0 8-3.6 8-8s-3.6-8-8-8zM296 112h-80c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8zM137.6 214c-3.2-3.2-8.4-3.2-11.2 0L104 236.8 81.6 214c-3.2-3.2-8-3.2-11.2 0s-3.2 8 0 11.2L93.2 248l-22.8 22.8c-3.2 3.2-3.2 8 0 11.2 1.6 1.6 3.6 2.4 5.6 2.4s4-.8 5.6-2.4l22.4-22.8 22.4 22.8c1.6 1.6 3.6 2.4 5.6 2.4s4-.8 5.6-2.4c3.2-3.2 3.2-8 0-11.2L115.2 248l22.8-22.8c2.8-3.2 2.8-8-.4-11.2zM296 256h-80c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8zM296 208h-80c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8z" fill={color}/>
    </svg>
)

export default class IconCalc extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
